var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-input"},_vm._l((12),function(value){return _c('div',{key:value-1,staticClass:"button-container",style:(_vm.gridParams[value-1])},[_c('button',{on:{"click":function($event){return _vm.solve(value-1)}}},[_vm._v(_vm._s(_vm.$t(_vm.noteNames[value-1])))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75639d2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonInput.vue
// module id = null
// module chunks = 